import { render } from "./InnerCartonParamPreviewButton.vue?vue&type=template&id=d65e6566"
import script from "./InnerCartonParamPreviewButton.vue?vue&type=script&lang=ts"
export * from "./InnerCartonParamPreviewButton.vue?vue&type=script&lang=ts"

import "./InnerCartonParamPreviewButton.vue?vue&type=style&index=0&id=d65e6566&lang=less"
script.render = render

export default script